import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import * as DashboardLabels from './display-labels';
import * as DashboardFormat from './dashboard-format';
import { buildCycleView } from './cycle-view';
import { AccountCashView } from './account-cash-view';
import { buildNextActionView } from './next-action-view';
const EMPTY_DASHBOARD: any = {
    target: null,
    strategy: { total_budget: 0, live_budget: 0, budget_mode: 'MANUAL' },
    kis_connection: { status: 'not_configured' },
    execution_control: { control_mode: 'PAUSE_BUY', state_version: 0,
        daily_auto_start_enabled: false, last_auto_started_on: null },
    live: {
        runtime: { status: 'STOPPED', reason: 'NOT_STARTED' },
        readiness: {}, execution_health: {},
        worker_stop: { allowed: true, reason: '' },
        account: null, market: { price: 0, chart: [] },
        cycle: null, active_order: null, recent_fills: []
    },
    shadow: {
        process: { running: false, phase: 'STOPPED' },
        runtime: {}, strategy: {}
    }
};

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.hn-live-page {
  max-width: 1240px;
  padding-top: 14px;
  animation: none;
}

.hn-dashboard-head {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 28px;
}

.hn-dashboard-head h1 {
  color: var(--hn-muted);
  font-size: 0.875rem;
  font-weight: 500;
}

.hn-dashboard-head h1:focus {
  outline: none;
}

.hn-dashboard-sync {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--hn-muted);
  font-size: 0.75rem;
}

.hn-dashboard-sync > span {
  width: 6px;
  height: 6px;
  background: #278366;
  border-radius: 50%;
}

.hn-dashboard-sync > span.is-stale {
  background: var(--hn-warn);
}

.hn-dashboard {
  display: grid;
  gap: 10px;
  margin-top: 8px;
}

.hn-dashboard h2, .hn-dashboard h3, .hn-dashboard strong {
  font-weight: 600;
}

.hn-dashboard dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.hn-dashboard button {
  cursor: pointer;
  font: inherit;
}

.hn-dashboard button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.hn-dashboard a:focus-visible, .hn-dashboard button:focus-visible, .hn-dashboard summary:focus-visible {
  outline: 3px solid #285ddd;
  outline-offset: 3px;
}

.hn-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.hn-section-icon {
  display: inline-grid;
  place-items: center;
  width: 26px;
  height: 26px;
  margin-right: 6px;
  border-radius: 8px;
  background: #edf1ff;
  color: #536cbd;
  font-size: 0.75rem;
}

.hn-account-card {
  min-width: 0;
  padding: 12px 18px 0;
  background: #fff;
  border: 1px solid #e0e5ed;
  border-radius: 14px;
}

.hn-account-card > header > div {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.hn-account-card h2 {
  margin: 0;
  font-size: 0.875rem;
}

.hn-account-meta, .hn-account-status {
  color: var(--hn-muted);
  font-size: 0.6875rem;
}

.hn-account-status {
  margin-left: auto;
}

.hn-account-status:not(.is-ok), .hn-account-context {
  color: #885a0b;
}

.hn-account-overview {
  display: grid;
  grid-template-columns: 1.15fr 1.15fr 1fr;
  gap: 16px;
  margin: 10px 0 0;
}

.hn-account-total {
  min-width: 0;
}

.hn-account-total + .hn-account-total {
  border-left: 1px solid var(--hn-line);
  padding-left: 18px;
}

.hn-account-total > span {
  display: block;
  font-size: 0.75rem;
  color: var(--hn-muted);
}

.hn-account-total strong {
  display: block;
  margin-top: 4px;
  font-size: clamp(1.25rem, 2.2vw, 1.75rem);
  letter-spacing: -0.04em;
  line-height: 1.3;
  overflow-wrap: anywhere;
  font-variant-numeric: tabular-nums;
}

.hn-account-total.is-cash strong {
  color: #285ddd;
}

.hn-account-total small {
  display: block;
  color: var(--hn-muted);
  font-size: 0.6875rem;
  line-height: 1.5;
  margin-top: 4px;
}

.hn-cash-source {
  display: flex !important;
  flex-wrap: wrap;
  gap: 2px 8px;
}

.hn-cash-source span, .hn-cash-source time {
  display: inline;
}

.hn-account-details summary, .hn-cycle-details summary {
  color: var(--hn-muted);
  cursor: pointer;
  font-size: 0.75rem;
  padding: 10px 0;
  min-height: 38px;
}

.hn-account-details {
  margin-top: 2px;
}

.hn-account-holding {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 10px 0 0;
}

.hn-account-holding dt {
  color: var(--hn-muted);
  font-size: 0.75rem;
}

.hn-account-holding dd {
  margin-top: 5px;
  font-size: 0.875rem;
}

.hn-account-note {
  color: var(--hn-muted);
  font-size: 0.75rem;
  line-height: 1.6;
  margin: 12px 0;
}

.hn-account-context {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0;
  font-size: 0.875rem;
}

.hn-account-empty {
  color: var(--hn-muted);
  font-size: 0.875rem;
  padding: 12px 0;
}

.hn-command-card {
  display: flex;
  align-items: center;
  gap: 12px 24px;
  flex-wrap: wrap;
  padding: 0 0 12px;
  border-bottom: 1px solid var(--hn-line);
}

.hn-command-tools {
  order: -1;
  flex-basis: 100% !important;
}

.hn-operation-title {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 10px;
}

.hn-operation-title > strong {
  font-size: 1rem;
}

.hn-operation-title > span {
  color: #59677c;
  font-size: 0.75rem;
}

.hn-command-state.is-warning .hn-command-signal {
  background: #b77913;
}

.hn-command-state.is-warning .hn-operation-title > span {
  color: #885a0b;
}

.hn-command-state.is-danger .hn-operation-title > span {
  color: #ad3731;
}

.hn-entry-focus {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px 24px;
  padding-top: 16px;
}

.hn-entry-price, .hn-entry-distance {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 5px;
}

.hn-entry-price > span, .hn-entry-distance > span {
  color: var(--hn-muted);
  font-size: 0.75rem;
}

.hn-entry-price > strong {
  color: #285ddd;
  font-size: clamp(1.5rem, 3vw, 2rem);
  letter-spacing: -0.04em;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.hn-entry-distance {
  padding-left: 20px;
  border-left: 1px solid var(--hn-line);
}

.hn-entry-distance > strong {
  font-size: 1.25rem;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.hn-entry-focus small {
  color: var(--hn-muted);
  font-size: 0.75rem;
  line-height: 1.5;
}

.hn-entry-details {
  grid-column: 1/-1;
  border-top: 1px solid var(--hn-line);
}

.hn-entry-details summary {
  cursor: pointer;
  padding: 12px 0;
  font-size: 0.75rem;
  color: var(--hn-muted);
  min-height: 44px;
}

.hn-entry-details p {
  font-size: 0.75rem;
  color: var(--hn-muted);
  line-height: 1.6;
}

.hn-focus-summary {
  flex: 1 1 260px;
  min-width: 0;
}

.hn-focus-kicker {
  color: var(--hn-muted);
  font-size: 0.8125rem;
  display: flex;
  gap: 8px;
}

.hn-focus-title {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 10px;
  margin: 5px 0;
  font-size: 1.5rem;
  letter-spacing: -0.03em;
}

.hn-focus-title > span {
  color: var(--hn-muted);
  font-size: 1rem;
}

.hn-focus-title--text {
  font-size: 1.125rem;
}

.hn-focus-description, .hn-focus-caption p {
  margin: 0;
  color: var(--hn-muted);
  font-size: 0.8125rem;
  line-height: 1.5;
}

.hn-focus-caption {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.hn-focus-caption em {
  font-size: 0.8125rem;
  font-style: normal;
  color: #3c526e;
}

.hn-cycle-order.is-warning .hn-focus-caption em {
  color: #885a0b;
}

.hn-cycle-order.is-danger .hn-focus-caption em {
  color: #ad3731;
}

.hn-focus-fill {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin: 8px 0 0;
}

.hn-focus-fill > div {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 0.8125rem;
}

.hn-focus-fill dt {
  color: var(--hn-muted);
}

.hn-command-tools {
  display: flex;
  flex: 1 1 440px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.hn-command-state {
  display: grid;
  grid-template-columns: 6px minmax(0, 1fr);
  gap: 9px;
}

.hn-command-state > div {
  display: grid;
  gap: 4px;
}

.hn-command-state strong {
  font-size: 0.875rem;
}

.hn-command-state p {
  color: var(--hn-muted);
  font-size: 0.8125rem;
  line-height: 1.5;
  margin: 0;
}

.hn-command-signal {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-top: 7px;
  background: #8a919c;
}

.hn-command-state.is-live .hn-command-signal {
  background: #248369;
}

.hn-command-state.is-danger .hn-command-signal {
  background: #c7423c;
}

.hn-control-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

.hn-control-actions button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
  border-radius: 8px;
  min-height: 44px;
  font-size: 0.8125rem;
  font-weight: 500;
  padding: 8px 12px;
}

.hn-live-button {
  background: #fff;
  border: 1px solid #d7dde6;
  color: #24344c;
}

.hn-live-button:not(.is-stop) {
  background: #285ddd;
  border-color: #285ddd;
  color: #fff;
}

.hn-live-button:hover:not(:disabled) {
  box-shadow: 0 2px 6px rgba(32, 54, 91, 0.0941176471);
}

.hn-emergency-button {
  border: 1px solid #e0c5c2;
  background: #fff;
  color: #ad3731;
}

.hn-emergency-button.is-on {
  background: #ad3731;
  color: #fff;
}

.hn-control-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 16px;
  flex-basis: 100%;
  padding: 12px;
  border: 1px solid #e4cca1;
  border-radius: 8px;
  background: #fff7e8;
  font-size: 0.875rem;
}

.hn-control-alert strong, .hn-control-alert span {
  display: block;
}

.hn-control-alert span {
  color: var(--hn-muted-strong);
  margin-top: 3px;
}

.hn-control-alert.is-danger {
  border-color: #e7aaa2;
  background: #fff0ed;
  color: #ad3731;
}

.hn-control-alert a, .hn-control-alert button, .hn-feedback button {
  background: #fff;
  border: 1px solid var(--hn-line-strong);
  border-radius: 8px;
  color: var(--hn-ink);
  font-size: 0.875rem;
  min-height: 44px;
  padding: 8px 12px;
  text-decoration: none;
}

.hn-dashboard-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(310px, 1fr);
  gap: 12px;
  align-items: start;
}

.hn-dashboard-rail {
  min-width: 0;
  grid-column: 1/-1;
}

.hn-cycle-card {
  background: #fff;
  border: 1px solid #e0e5ed;
  border-radius: 14px;
  padding: 14px 18px 0;
  min-width: 0;
}

.hn-cycle-card > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.hn-cycle-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 16px;
  min-width: 0;
}

.hn-cycle-heading h2 {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  margin: 0;
}

.hn-cycle-heading .hn-section-icon {
  background: #f0eaff;
  color: #8263ba;
}

.hn-cycle-identity {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 8px;
}

.hn-cycle-identity strong {
  font-size: 0.875rem;
}

.hn-cycle-identity span, .hn-cycle-phase {
  color: var(--hn-muted);
  font-size: 0.6875rem;
}

.hn-cycle-phase {
  margin: 0;
}

.hn-status-chip {
  font-size: 0.6875rem;
  background: #edf5f1;
  color: #267255;
  border-radius: 20px;
  padding: 4px 8px;
  white-space: nowrap;
}

.hn-status-chip.is-waiting {
  background: #f0f2f6;
  color: var(--hn-muted);
}

.hn-status-chip.is-warning {
  background: #fff0d7;
  color: #885a0b;
}

.hn-cycle-content {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 2fr);
  column-gap: 24px;
  row-gap: 0;
  padding-top: 12px;
}

.hn-position-group {
  min-width: 0;
  padding: 4px 0;
}

.hn-cycle-position {
  display: grid;
  gap: 8px;
  margin: 0;
}

.hn-cycle-position > div {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.hn-cycle-position dt {
  font-size: 0.75rem;
  color: var(--hn-muted);
  flex-shrink: 0;
}

.hn-cycle-position dd {
  font-size: 1.0625rem;
  letter-spacing: -0.025em;
  font-weight: 600;
  text-align: right;
}

.hn-cycle-next {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  min-width: 0;
}

.hn-cycle-next > div {
  min-width: 0;
  border-left: 2px solid #d8e4fb;
  padding-left: 14px;
}

.hn-cycle-next > .hn-next-sell {
  border-color: #cee7d9;
}

.hn-action-heading {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 8px;
}

.hn-cycle-next h4 {
  color: #44546f;
  font-size: 0.75rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
}

.hn-cycle-next small {
  color: var(--hn-muted);
  font-size: 0.75rem;
}

.hn-cycle-next strong {
  display: block;
  font-size: 1.375rem;
  letter-spacing: -0.035em;
  line-height: 1.3;
  margin: 3px 0;
  overflow-wrap: anywhere;
}

.hn-cycle-next em {
  display: block;
  color: var(--hn-muted);
  font-size: 0.6875rem;
  font-style: normal;
  line-height: 1.5;
}

.hn-next-buy strong {
  color: #285ddd;
}

.hn-next-sell strong {
  color: #267255;
}

.hn-next-note {
  color: var(--hn-muted);
  font-size: 0.6875rem;
  line-height: 1.5;
  margin: 2px 0 0;
}

.hn-cycle-details {
  grid-column: 1/-1;
  margin-top: 6px;
}

.hn-cycle-roadmap {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  list-style: none;
  gap: 12px;
  padding: 4px 0 12px;
  margin: 0;
}

.hn-cycle-roadmap li {
  color: var(--hn-muted);
  font-size: 0.8125rem;
}

.hn-cycle-roadmap i {
  display: block;
  height: 3px;
  border-radius: 3px;
  background: #e7eaf0;
  margin-bottom: 7px;
}

.hn-cycle-roadmap li.is-done i {
  background: #a9bad5;
}

.hn-cycle-roadmap li.is-current i {
  background: #285ddd;
}

.hn-cycle-roadmap li.is-current {
  color: #285ddd;
}

.hn-cycle-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 0;
  padding: 12px 0;
}

.hn-cycle-metrics dt {
  color: var(--hn-muted);
  font-size: 0.8125rem;
}

.hn-cycle-metrics dd {
  font-size: 1rem;
  margin-top: 5px;
}

.hn-cycle-meta, .hn-buy-plan {
  color: var(--hn-muted);
  font-size: 0.75rem;
  line-height: 1.6;
  margin: 0 0 12px;
}

.hn-cycle-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
}

.hn-cycle-notice, .hn-cycle-wait {
  grid-column: 1/-1;
  background: #fff7e8;
  color: #885a0b;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 10px 12px;
  border-radius: 8px;
  margin: 0 0 12px;
}

.hn-cycle-plan {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin: 18px 0;
}

.hn-cycle-plan dt {
  color: var(--hn-muted);
  font-size: 0.8125rem;
}

.hn-cycle-plan dd {
  font-size: 0.875rem;
  margin-top: 6px;
}

.hn-order-distance {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px 14px;
}

.hn-order-distance small, .hn-order-distance span {
  color: var(--hn-muted);
  font-size: 0.8125rem;
}

.hn-order-distance strong {
  font-size: 1.5rem;
}

.hn-dashboard-grid.is-entry-wait .hn-order-distance {
  grid-column: 1/-1;
}

.hn-market-card {
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e0e5ed;
  border-radius: 14px;
}

.hn-market-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px 6px;
}

.hn-market-identity, .hn-market-identity > div {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
}

.hn-market-identity h2 {
  font-size: 0.9375rem;
  margin: 0;
}

.hn-market-identity > div > span {
  color: var(--hn-muted);
  font-size: 0.75rem;
}

.hn-session-badge {
  color: var(--hn-muted);
  font-size: 0.75rem;
  background: #f1f4f8;
  border-radius: 5px;
  padding: 4px 7px;
}

.hn-market-price {
  display: grid;
  justify-items: end;
  gap: 4px;
}

.hn-market-price > small, .hn-market-time {
  color: var(--hn-muted);
  font-size: 0.6875rem;
}

.hn-market-price-value {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.hn-market-price-value strong {
  font-size: 1.5rem;
  letter-spacing: -0.04em;
}

.hn-market-price-value em {
  font-size: 0.8125rem;
  font-style: normal;
}

.hn-market-time {
  flex-basis: 100%;
  text-align: right;
}

.hn-market-price.is-up .hn-market-price-value {
  color: #bd3f3a;
}

.hn-market-price.is-down .hn-market-price-value {
  color: #285ddd;
}

.hn-activity-card {
  min-width: 0;
  background: #fff;
  border: 1px solid #e0e5ed;
  border-radius: 14px;
  padding: 0 14px 8px;
}

.hn-activity-card > header {
  border-bottom: 1px solid var(--hn-line);
}

.hn-activity-card > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.hn-activity-card h2 {
  font-size: 0.9375rem;
  margin: 0;
}

.hn-activity-card > header a {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--hn-muted);
  font-size: 0.8125rem;
  min-height: 44px;
  padding: 8px;
  text-decoration: none;
}

.hn-activity-card > header a i {
  font-size: 0.625rem;
}

.hn-activity-card > wiz-component-cycle-history {
  display: block;
  padding: 0;
}

.hn-feedback {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
  padding: 14px;
  background: #fff;
  border: 1px solid var(--hn-line);
  border-radius: 10px;
  font-size: 0.875rem;
}

.hn-feedback.is-error {
  color: #ad3731;
}

.hn-feedback.is-warning {
  background: #fff7e8;
  border-color: #e4cca1;
  color: #885a0b;
}

.hn-feedback strong, .hn-feedback small {
  display: block;
}

.hn-feedback small {
  margin-top: 4px;
}

.is-up {
  color: #bd3f3a !important;
}

.is-down {
  color: #285ddd !important;
}

@media (max-width: 1050px) {
  .hn-dashboard-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 760px) {
  .hn-cycle-content {
    grid-template-columns: minmax(0, 1fr);
  }
  .hn-cycle-position {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    padding-bottom: 10px;
  }
  .hn-cycle-next {
    border-top: 1px solid var(--hn-line);
    padding-top: 10px;
  }
  .hn-cycle-heading {
    gap: 4px 10px;
  }
  .hn-cycle-phase {
    flex-basis: 100%;
  }
}
@media (max-width: 560px) {
  .hn-live-page {
    padding: 10px 12px 24px;
  }
  .hn-dashboard {
    gap: 8px;
    margin-top: 6px;
  }
  .hn-dashboard-head {
    flex-wrap: wrap;
  }
  .hn-account-card, .hn-cycle-card {
    padding: 10px 12px 0;
  }
  .hn-account-overview {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 12px;
  }
  .hn-account-total + .hn-account-total {
    padding-left: 12px;
  }
  .hn-account-total strong {
    font-size: clamp(1.0625rem, 5vw, 1.5rem);
  }
  .hn-account-total.hn-account-metrics {
    grid-column: 1/-1;
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 4px 8px;
    border: 0;
    border-top: 1px solid var(--hn-line);
    padding: 8px 0 0;
  }
  .hn-account-metrics strong {
    font-size: 0.875rem;
    margin: 0 0 0 auto;
  }
  .hn-account-metrics small {
    margin: 0;
  }
  .hn-account-holding {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .hn-command-card {
    padding: 0 0 10px;
    gap: 8px;
  }
  .hn-entry-focus {
    column-gap: 12px;
    padding-top: 12px;
  }
  .hn-entry-distance {
    padding-left: 12px;
  }
  .hn-entry-distance > strong {
    font-size: 1rem;
  }
  .hn-command-tools {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .hn-command-state {
    flex: 1 1 120px;
    align-self: center;
  }
  .hn-command-state strong {
    font-size: 0.8125rem;
  }
  .hn-command-state p {
    font-size: 0.75rem;
  }
  .hn-control-actions {
    flex-shrink: 1;
  }
  .hn-control-actions button {
    font-size: 0.75rem;
    padding: 8px;
  }
  .hn-cycle-content {
    padding-top: 8px;
  }
  .hn-cycle-card > header {
    align-items: flex-start;
  }
  .hn-cycle-identity {
    flex-basis: 100%;
  }
  .hn-cycle-position {
    gap: 12px;
  }
  .hn-cycle-position > div {
    flex-wrap: wrap;
    gap: 2px 6px;
  }
  .hn-cycle-position dd {
    font-size: 1rem;
  }
  .hn-cycle-next {
    gap: 12px;
  }
  .hn-cycle-next > div {
    padding-left: 8px;
  }
  .hn-cycle-next strong {
    font-size: clamp(1.0625rem, 4.7vw, 1.3125rem);
  }
  .hn-cycle-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .hn-cycle-plan {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }
  .hn-cycle-plan > div {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 14px;
  }
  .hn-cycle-plan dt {
    flex-shrink: 0;
  }
  .hn-cycle-plan dd {
    margin: 0;
    text-align: right;
  }
  .hn-market-head {
    padding: 12px 12px 6px;
    gap: 8px;
  }
  .hn-market-price {
    justify-items: start;
    width: 100%;
    gap: 4px;
  }
  .hn-market-time {
    text-align: left;
  }
  .hn-activity-card {
    padding: 0 12px 6px;
  }
}
@media (max-width: 380px) {
  .hn-live-page {
    padding-left: 10px;
    padding-right: 10px;
  }
  .hn-cycle-roadmap {
    gap: 6px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .hn-dashboard *, .hn-dashboard *::before {
    animation: none !important;
    transition: none !important;
  }
}
@media (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) {
  .hn-live-button {
    transition: background-color 0.15s ease, box-shadow 0.15s ease;
  }
}
@media (prefers-contrast: more) {
  .hn-cycle-card, .hn-market-card {
    border-color: #8995a6;
  }
  .hn-dashboard {
    --hn-muted: #455063;
  }
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public readonly formatAge = DashboardFormat.formatAge;
    public readonly formatKstDateTime = DashboardFormat.formatKstDateTime;
    public readonly formatMoney = DashboardFormat.formatMoney;
    public readonly formatNumber = DashboardFormat.formatNumber;
    public readonly formatOptionalMoney = DashboardFormat.formatOptionalMoney;
    public readonly formatOptionalPrice = DashboardFormat.formatOptionalPrice;
    public readonly formatPercent = DashboardFormat.formatPercent;
    public readonly formatPrice = DashboardFormat.formatPrice;
    public readonly formatSignedMoney = DashboardFormat.formatSignedMoney;
    public readonly formatTime = DashboardFormat.formatTime;
    public dashboard: any = EMPTY_DASHBOARD;
    public cashView = new AccountCashView();
    public loading = true;
    public loadError = '';
    public refreshWarning = '';
    public busy = false;
    public lastLoadedAt: Date | null = null;
    public cycleView: any = buildCycleView(null, null, null);
    private timer: any = null;
    private destroyed = false;
    private hasLoaded = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
        this.schedulePoll();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.timer) clearTimeout(this.timer);
    }

    private schedulePoll() {
        if (this.destroyed) return;
        this.timer = setTimeout(async () => {
            if (!this.busy) await this.load(true);
            this.schedulePoll();
        }, document.hidden ? 30000 : 5000);
    }

    public async load(silent = false) {
        if (!silent) this.loading = true;
        this.loadError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('overview');
            if (code !== 200 || !data) {
                throw new Error(this.responseMessage(data, '잠시 후 다시 시도해주세요.'));
            }
            this.acceptDashboard(data);
        } catch (error: any) {
            const message = error?.message || '잠시 후 다시 시도해주세요.';
            if (silent && this.hasLoaded) {
                this.refreshWarning =
                    '새 상태를 불러오지 못했습니다. 마지막 정상 상태를 표시합니다.';
            } else {
                this.loadError = message;
            }
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private acceptDashboard(data: any) {
        this.dashboard = data;
        void this.cashView.refresh(data.target?.code || '', () => wiz.call('account_cash'), () => this.destroyed ? Promise.resolve() : this.service.render());
        this.cycleView = buildCycleView(
            this.cycle,
            this.activeOrder,
            this.chartStrategy,
            role => this.roleLabel(role),
            status => this.statusLabel(status)
        );
        this.lastLoadedAt = new Date();
        this.hasLoaded = true;
        this.refreshWarning = '';
    }

    private responseMessage(data: any, fallback: string) {
        return data?.message || (typeof data === 'string' ? data : fallback);
    }

    public get live() { return this.dashboard.live || {}; }
    public get runtime() { return this.live.runtime || {}; }
    public get readiness() { return this.live.readiness || {}; }
    public get executionHealth() { return this.live.execution_health || {}; }
    public get market() { return this.live.market || {}; }
    public get account() { return this.live.account || null; }
    public get cycle() { return this.live.cycle || null; }
    public get activeOrder() { return this.live.active_order || null; }
    public get recentFills() { return this.live.recent_fills || []; }
    public get nextAction() { return buildNextActionView(this); }
    public get recentCycles() {
        const cycles = [...(this.live.recent_cycles || [])];
        if (this.cycle && !cycles.some(item => item?.id === this.cycle.id)) {
            cycles.unshift(this.cycle);
        }
        return cycles.slice(0, 3);
    }
    public get chartStrategy() {
        const strategy = (this.cycle
            ? this.dashboard.strategy_context?.active_cycle
            : this.dashboard.strategy_context?.next_cycle)
            || this.dashboard.strategy_context?.next_cycle
            || this.dashboard.shadow?.strategy;
        return (
            strategy?.parameters?.entry_reference === 'PREVIOUS_CLOSE'
            && Number(strategy.parameters.entry_drop_pct || 0) > 0
        ) ? strategy : null;
    }
    public get control() { return this.dashboard.execution_control || {}; }
    public get process() { return this.dashboard.shadow?.process || {}; }
    public get controlRequested() { return this.control.control_mode === 'RUNNING'; }
    public get autoStartEnabled() { return this.control.daily_auto_start_enabled === true; }
    public get automationEnabled() { return this.controlRequested || this.autoStartEnabled; }
    public get isRunning() { return this.executionHealth.active === true; }
    public get executionMismatch() { return this.controlRequested && !this.isRunning; }
    public get emergency() { return this.control.control_mode === 'EMERGENCY_STOP'; }
    public get ready() { return this.readiness.ready === true; }
    public get cycleNotice() {
        return this.cycleView.notice || '';
    }

    public levelDistanceLabel(price: any) {
        const current = this.marketPrice;
        const target = Number(price || 0);
        if (current <= 0 || target <= 0) return '';
        return this.formatPercent((target / current - 1) * 100);
    }

    public get readinessMessage() {
        return this.readinessIssue.message;
    }

    public get automationLabel() {
        if (this.emergency) return '긴급 정지';
        if (this.executionMismatch) return '실행 확인 필요';
        if (this.runtime.daily_loss_latched) return '오늘 매수 종료';
        if (this.control.reason_code === 'MARKET_OPEN_AUTO_MISSED') return '다음 장 시작 대기';
        if (this.control.reason_code === 'AUTO_START_DATE_INVALID') return '자동 시작 날짜 확인 필요';
        if (this.autoStartEnabled && !this.controlRequested) return '장 시작 대기';
        if (this.controlRequested && this.marketSession !== 'REGULAR') return '장 시작 대기';
        return this.controlRequested ? '켜짐' : '꺼짐';
    }

    public get showEmergencyAction() {
        return this.emergency || this.controlRequested
            || this.activeOrder?.side === 'BUY';
    }

    public get liveActionDisabled() {
        const startBlocked = !this.automationEnabled && (
            !this.ready || this.runtime.daily_loss_latched || !!this.refreshWarning
        );
        return this.busy || this.emergency || startBlocked;
    }

    public get runtimeReasonLabel() {
        if (this.runtime.stale) return '자동 주문 시스템의 상태 갱신이 늦습니다.';
        if (this.executionMismatch) {
            if (this.executionHealth.realtime_ready === false && this.marketSession === 'REGULAR') {
                return this.dashboard.shadow?.runtime?.error_message
                    || '최신 실시간 시세를 받지 못해 매수·매도 판단을 기다리고 있습니다.';
            }
            return '매수 실행 요청과 실제 주문 서버 상태가 다릅니다.';
        }
        const reason = String(this.runtime.reason || 'NOT_STARTED');
        return DashboardLabels.reasonLabel(reason);
    }

    public get marketPrice() { return Number(this.market.price || 0); }

    public get marketChangeAmount(): number | null {
        const price = this.marketPrice;
        const previousClose = Number(this.market.previous_close || 0);
        if (price <= 0 || previousClose <= 0) return null;
        return price - previousClose;
    }

    public get marketChangePct(): number | null {
        const previousClose = Number(this.market.previous_close || 0);
        if (this.marketChangeAmount === null || previousClose <= 0) return null;
        return this.marketChangeAmount / previousClose * 100;
    }

    public get marketPriceUp() { return Number(this.marketChangeAmount || 0) > 0; }
    public get marketPriceDown() { return Number(this.marketChangeAmount || 0) < 0; }

    public get marketPriceLabel() {
        return this.market.price_source === 'REALTIME'
            ? '실시간 체결가' : '최근 확정가';
    }

    public get marketCalendar() {
        return this.dashboard.shadow?.runtime?.calendar || {};
    }

    public get marketSession() {
        return String(
            this.marketCalendar.market_session
            || this.dashboard.shadow?.runtime?.market_session
            || 'CALENDAR_UNKNOWN'
        ).toUpperCase();
    }

    public get chartSessionLabel() {
        return DashboardLabels.marketSessionLabel(
            this.marketSession,
            this.dashboard.shadow?.server_at || '',
            this.marketCalendar.market_open_at || ''
        );
    }

    public get marketTimeLabel() {
        if (this.market.price_source === 'REALTIME' && this.market.price_at) {
            return `${this.formatKstDateTime(this.market.price_at)} KST · 실시간`;
        }
        if (!this.market.opened_at) return '확정 1분봉이 없습니다.';
        const time = this.formatKstDateTime(this.market.opened_at);
        if (DashboardLabels.showsLastRegularBar(this.marketSession)) {
            return `${time} KST · 마지막 장 기준`;
        }
        if (this.market.delayed) {
            return `${time} KST · ${this.formatAge(this.market.age_seconds)} 전`;
        }
        return `${time} KST · 확정 1분봉`;
    }

    public get accountStatusLabel() {
        if (!this.account) return '확인 전';
        if (this.accountReadDelayed) return '조회 지연 · 재확인 중';
        if (!this.accountMatched) return '잔고 확인 필요';
        return this.accountRefreshDelayed ? '업데이트 지연' : '확인 완료';
    }

    public get accountRefreshDelayed() {
        if (!this.account) return false;
        const rawAge = this.account.reconciliation_age_seconds;
        if (rawAge === null || rawAge === undefined || rawAge === '') {
            return this.account.stale === true;
        }
        const age = Number(rawAge);
        if (!Number.isFinite(age)) return true;
        const allowedAge = this.marketSession === 'REGULAR' ? 90 : 360;
        return age > allowedAge;
    }

    public get accountMatched() {
        return !!this.account
            && this.account.reconciliation_status === 'MATCH'
            && String(this.account.symbol || '')
                === String(this.dashboard.target?.code || '')
            && this.account.broker_matches_ledger === true;
    }

    public get accountReadDelayed() {
        return this.account?.reconciliation_status === 'UNKNOWN'
            && this.account.broker_matches_ledger === true
            && this.account.symbol === this.dashboard.target?.code
            && this.account.active_order_id === this.activeOrder?.id
            && DashboardLabels.isTemporaryOrderReadDelay(this.activeOrder);
    }

    public get hasHolding() {
        return Number(this.account?.position_quantity || 0) > 0;
    }

    public get readinessIssue() {
        const issue = DashboardLabels.readinessIssue(this.readiness);
        if (issue.key === 'account' && this.accountReadDelayed) {
            return { ...issue, message: 'KIS 조회 재시도 중 · 새 주문은 확인 후 진행합니다.', action: '' };
        }
        if (issue.key === 'order_server' && this.process.running) {
            return { ...issue, message: '주문 서버 상태 갱신이 늦습니다.', action: '' };
        }
        if (issue.key === 'live_order') {
            if (!this.process.live_order_enabled) {
                return { ...issue, message: '서버의 실주문 전송 설정이 꺼져 있습니다.' };
            }
            if (!this.process.credentials_rotated) {
                return { ...issue, message: '운영 자격정보 교체 확인이 필요합니다.' };
            }
            if (!['CANARY', 'FULL'].includes(String(this.process.rollout_mode))) {
                return { ...issue, message: '실전 매수 단계를 설정해주세요.' };
            }
            const maximum = Number(this.process.max_buy_notional);
            if (this.process.rollout_mode === 'CANARY'
                && (!Number.isFinite(maximum) || maximum <= 0 || maximum > 100_000_000)) {
                return { ...issue, message: '1회 매수 상한을 설정해주세요.' };
            }
        }
        return issue;
    }

    public get operatingBudgetLabel() {
        if (this.cycle) {
            return this.formatMoney(
                this.cycle.committed_limit || this.cycle.budget
            );
        }
        const next = this.dashboard.strategy_context?.next_cycle || {};
        const mode = this.dashboard.strategy?.budget_mode;
        const preflight = this.live.preflight || {};
        const currentPreflight = preflight.integrity === true
            && preflight.budget_mode === 'AUTO'
            && !!next.version && preflight.strategy_version === next.version;
        const limit = mode === 'AUTO'
            ? (currentPreflight ? Number(preflight.committed_budget || 0) : 0)
            : Number(next.live_committed_limit || 0);
        if (limit > 0) return this.formatMoney(limit);
        const rate = Number(next.max_committed_pct ?? 100);
        return mode === 'AUTO'
            ? `계좌 잔액의 ${rate}%` : this.formatMoney(this.dashboard.strategy?.live_budget);
    }

    public async toggleLive() {
        if (this.busy || this.emergency) return;
        const start = !this.automationEnabled;
        if (start && this.refreshWarning) {
            await this.service.modal.error('최신 상태를 다시 불러온 뒤 매수를 시작해주세요.');
            return;
        }
        if (start && !this.ready) {
            await this.service.modal.error(this.readinessMessage);
            return;
        }
        if (start && this.runtime.daily_loss_latched) {
            await this.service.modal.error('오늘은 새 매수를 시작할 수 없습니다.');
            return;
        }
        const prompt = start
            ? `자동매수를 켤까요? 매 거래일 장 시작에 자동으로 준비하며 운용 한도는 ${this.operatingBudgetLabel}입니다.`
            : '새 매수와 다음 장 자동 시작을 끌까요? 진행 중인 매도와 주문 확인은 계속됩니다.';
        if (!await this.confirm(prompt, start ? '시작' : '중지')) return;
        await this.controlCall(start ? 'start_live' : 'pause_live', {
            state_version: this.control.state_version,
            confirmation: start ? 'LIVE 시작' : ''
        });
    }

    public async toggleEmergency() {
        if (this.busy) return;
        const release = this.emergency;
        const prompt = release
            ? '긴급 정지를 해제할까요? 새 매수는 중지 상태로 돌아갑니다.'
            : '긴급 정지할까요? 새 매수를 막고 미체결 매수 잔량을 취소합니다.';
        if (!await this.confirm(prompt, release ? '해제' : '긴급 정지')) return;
        await this.controlCall(
            release ? 'release_emergency_stop' : 'emergency_stop',
            release ? { state_version: this.control.state_version } : {}
        );
    }

    public async startSystem() {
        if (this.busy || this.process.running) return;
        if (this.refreshWarning) {
            await this.service.modal.error(
                '최신 상태를 다시 불러온 뒤 시스템을 켜주세요.'
            );
            return;
        }
        if (this.controlRequested) {
            const confirmed = await this.confirm(
                '남아 있는 자동매수 요청을 중지한 뒤 시스템만 켤까요?',
                '중지 후 켜기'
            );
            if (!confirmed) return;
            const paused = await this.controlCall('pause_live', {
                state_version: this.control.state_version
            });
            if (!paused) return;
        }
        await this.controlCall('start_shadow', {});
    }

    private confirm(message: string, action: string) {
        return this.service.modal.warning(message, '취소', action);
    }

    private async controlCall(action: string, payload: any) {
        this.busy = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call(action, payload);
            if (code !== 200 || !data) {
                await this.service.modal.error(
                    this.responseMessage(data, '상태를 변경하지 못했습니다.')
                );
                return false;
            }
            this.acceptDashboard(data);
            return true;
        } catch {
            await this.service.modal.error('상태 변경 요청을 완료하지 못했습니다.');
            return false;
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public roleLabel(role: string) {
        if (role === 'INITIAL_BUY') return '첫 매수';
        if (role?.startsWith('ADD_BUY')) return '추가 매수';
        if (role?.startsWith('ADD_SELL')) return '추가매수분 매도';
        if (role?.startsWith('PARTIAL_SELL')) return `${role.slice(-1)}차 매도`;
        if (role?.startsWith('REBUY')) return '재매수';
        if (role?.startsWith('RECYCLE_SELL')) return '재매수분 매도';
        return '주문';
    }

    public statusLabel(status: string) {
        return DashboardLabels.statusLabel(status);
    }

}

export default PageDashboardComponent;